import { render, staticRenderFns } from "./ProductInventoryBox.vue?vue&type=template&id=d9494e4c&scoped=true"
import script from "./ProductInventoryBox.vue?vue&type=script&lang=js"
export * from "./ProductInventoryBox.vue?vue&type=script&lang=js"
import style0 from "./ProductInventoryBox.vue?vue&type=style&index=0&id=d9494e4c&prod&scoped=true&lang=css"
import style1 from "./ProductInventoryBox.vue?vue&type=style&index=1&id=d9494e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9494e4c",
  null
  
)

export default component.exports